import React from "react";
import { Stylesilla } from "./style";
import { displayMesaNombre } from "utils/constantes";

const Silla = ({ n, text, obtenerid, succesSilla, Estado }) => (
  <a id={obtenerid(text + "-s-" + n)}
    onClick={() => succesSilla(text + "-s-" + n)}
    className={text + "-s-" + n + " sillas " + Estado(text + "-s-" + n) + " d-flex justify-content-center text-white align-items-center"}
    style={Stylesilla.asientos}>
    <span style={{ fontSize: n >= 10 ? '0.45rem' : '0.6rem' }}>{n}</span>
  </a>
);

/**
 * Plantilla dinámica para mesas con más de 10 sillas.
 * Las sillas 1-10 siguen el layout estándar.
 * Las sillas extras (11 en adelante) aparecen arriba en filas de 4.
 */
const MesaExtraView = ({ text, list, obtenerid, alert, succesSilla, Estado, MesaEstado, enviarsillas }) => {
  const s = (n) => (
    <Silla key={n} n={n} text={text} obtenerid={obtenerid} succesSilla={succesSilla} Estado={Estado} />
  );

  // Sillas extras: 11 hasta list.length
  const extras = Array.from({ length: list.length - 10 }, (_, i) => i + 11);

  // Dividir extras en filas de 4
  const filas = [];
  for (let i = 0; i < extras.length; i += 4) {
    filas.push(extras.slice(i, i + 4));
  }

  return (
    <div style={{ padding: '0.7px' }}>
      {alert}

      {/* Filas de sillas extras arriba */}
      {filas.map((fila, fi) => (
        <div key={fi} className="d-flex justify-content-center" style={{ marginBottom: '1px' }}>
          {fila.map(n => s(n))}
        </div>
      ))}

      {/* Layout estándar de 10 sillas */}
      <div className="d-flex">
        <div style={{ margin: '0.1px', height: '5px', width: '15px', borderRadius: '5px' }} />
        {[1, 2, 3].map(n => s(n))}
      </div>
      <div className="d-flex align-items-center">
        <div className="d-flex flex-column">
          {[4, 5].map(n => s(n))}
        </div>
        <div id={text}
          className={text + " " + list.length + " Mesa txt-white d-flex p-1 " + MesaEstado(text)}
          onClick={() => enviarsillas(text)}
          style={Stylesilla.mesas}>
          {displayMesaNombre(text)}
        </div>
        <div className="d-flex flex-column">
          {[6, 7].map(n => s(n))}
        </div>
      </div>
      <div className="d-flex">
        <div style={{ margin: '0.1px', height: '5px', width: '15px', borderRadius: '5px' }} />
        {[8, 9, 10].map(n => s(n))}
      </div>
    </div>
  );
};

export default MesaExtraView;
